export type IntrusionStatusValues = readonly (string | null | undefined)[] | null | undefined;

const normalizeStatusValue = (value: string | null | undefined): string => String(value ?? '').trim();

export const normalizeIntrusionStatusValueKey = (value: string | null | undefined): string =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');

export const normalizeIntrusionStatusValues = (values: IntrusionStatusValues): string[] =>
  (values ?? []).map(normalizeStatusValue).filter(Boolean);

/**
 * True when the panel reports any alarm at all. `alarmValues` is the computed decode of the `alarm`
 * bitmask, so each entry *names* an alarm ("Burglary", "Fire", "Low Battery", "Panic") and none of
 * them contains the word "alarm" - the presence of any value is the signal, not a pattern match.
 */
export const hasIntrusionAlarm = (values: IntrusionStatusValues): boolean =>
  normalizeIntrusionStatusValues(values).length > 0;

export const formatIntrusionStatusValues = (...valueGroups: IntrusionStatusValues[]): string => {
  const seenValues = new Set<string>();

  return valueGroups
    .flatMap(normalizeIntrusionStatusValues)
    .filter((value) => {
      const key = normalizeIntrusionStatusValueKey(value);

      if (!key || seenValues.has(key)) {
        return false;
      }

      seenValues.add(key);
      return true;
    })
    .join(', ');
};

export const formatIntrusionStatusMatcherText = (...valueGroups: IntrusionStatusValues[]): string =>
  valueGroups.flatMap(normalizeIntrusionStatusValues).join(' ');
